import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Main from "./main";
import * as ActionCreators from "./redux/action-creators";

const mapStateToProps = (state) => {
  return {
    memberType: state.system.userProfile.memberType,
    isFetching: state.system.userProfile.isFetching,
    ...state.manageUsers,
  };
};

export default withRouter(
  connect(mapStateToProps, { ...ActionCreators })(Main)
);
